import { CheckInviteResponse } from '@quadminds/client-apis/users';
import { useSearchParams } from 'react-router-dom';
import { ValidatedInvite, validateInvite } from '../utils';

/**
 * It returns an object with boolean properties by each valid conditions
 * @returns {ValidatedInvite}  A ValidatedInvite object.
 */

export const useValidateInvite = (foundInvite: CheckInviteResponse | undefined): ValidatedInvite => {
    const [searchParams] = useSearchParams();
    const organizationId = searchParams.get('organization') || '';
    const result = validateInvite(foundInvite, organizationId);
    return result;
};
